/**
 * @module OMPTypes - омеговские типы
 */

export interface OMPFileData {
    Code: number;
    Value: string;
}

/**
 * Вариации учета регистра ввода поиска по {@link OMPSearchString}:
 * - `"case_independent"` - вне зависимости от регистра
 * - `"case_dependent"` - исключительно в соотвествии с регистром
 */
type OmpSearchStringCs = "case_independent" | "case_dependent";

export interface OMPSearchString {
    /** Флаг учета регистра */
    cs?: OmpSearchStringCs;
    /** Значение по которому производится поиск, может использовать доп символы в виде % */
    val?: string;
    /**
     * Введеное пользователем значение, для хранения искомого пользовательского ввода. \
     * Используется только на фронте. Нужно, когда идёт автооборачивание в %
     */
    _query?: string;
}
/**
 * Функция формирования {@link OMPSearchString}.
 * @param query - запрос пользователя
 * @param params - параметры поиска. По умолчанию `{}`
 * @param params.cs - флаг учета регистра, По умолчанию  `"case_independent"`
 * @param params.fullTextSearch - если true оборачивает `query` в утилитарные % %. По умолчанию = `false`
 * @returns undefined, если query = undefined или "", иначе OMPSearchString
 */
export const getOmpSearchString = (
    query: string | undefined,
    params: {
        cs?: OmpSearchStringCs;
        fullTextSearch?: boolean;
    } = {},
): OMPSearchString | undefined => {
    const { cs = "case_independent", fullTextSearch = false } = params;

    if (query === undefined || query === "") return undefined;

    const val = fullTextSearch ? `%${query}%` : query;

    return { val, cs, _query: query };
};
